import { QueryClient } from "@tanstack/react-query";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,        // 30 seconds default
      gcTime: 5 * 60 * 1000,       // 5 minutes garbage collection
      retry: 2,
      refetchOnWindowFocus: false,
    },
  },
});

export default queryClient;
